module.exports = __webpack_public_path__ + "9ac7fb4683c5d105b26f76598ed32e91.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/armagan-amcalar.jpg
// module id = 432
// module chunks = 0